import { InfoTooltip } from '@elementary/common-ui/components';

const TrainingPeriodInfoTooltip = () => (
  <InfoTooltip
    size={16}
    title={
      <>
        Supported training periods are: 7–90 days, 1–12 weeks, 1–3 months.
        <br />
        For a different training period please contact support.
      </>
    }
  />
);

export default TrainingPeriodInfoTooltip;
